import { downloadFile } from 'lib/helpers/downloadFile';
import { useToast } from 'lib/hooks';
import { cloneElement, ReactElement } from 'react';
import { getActiveLearnersCsv } from './api';
import { PopulationCsvDownloadProps } from './types';

type PopulationCsvDownloadTriggerProps = PopulationCsvDownloadProps & {
  children: ReactElement;
};

export const PopulationCsvDownloadTrigger = ({
  children,
  fallbackFilename = 'population.csv',
  ...rest
}: PopulationCsvDownloadTriggerProps) => {
  const { message } = useToast();

  switch (rest.mode) {
    case 'default':
      if (!rest.searchParams) {
        throw new Error(
          'PopulationCsvDownloadTrigger requires `searchParams` to be provided for default behaviour.'
        );
      }
      break;
    case 'custom':
      if (!rest.getCsvData) {
        throw new Error(
          'PopulationCsvDownloadTrigger requires `getCsvData` to be provided for custom behaviour.'
        );
      }
      break;
  }

  const handleClick = async () => {
    try {
      const response =
        rest.mode === 'default'
          ? await getActiveLearnersCsv(rest.searchParams)
          : await rest.getCsvData();

      if (response.error) {
        throw new Error(response.message);
      }

      downloadFile({
        response,
        fallbackFilename,
      });
    } catch (e) {
      message.error(`Could not download population CSV: ${e.message}`);
    }
  };

  return cloneElement(children, {
    onClick: handleClick,
  });
};
